import { render, staticRenderFns } from "./TemOne.vue?vue&type=template&id=f768a136&scoped=true&"
import script from "./TemOne.vue?vue&type=script&lang=js&"
export * from "./TemOne.vue?vue&type=script&lang=js&"
import style0 from "./TemOne.vue?vue&type=style&index=0&id=f768a136&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f768a136",
  null
  
)

export default component.exports